import { createSlice } from "@reduxjs/toolkit"
import { Project } from "@/api/projects"

export const projectsSlice = createSlice({
    name: "projects",
    initialState: {
        projects: [] as Project[],
        currentProject: null as Project | null,
        selectedProjectId: null as string | null,
        isLoading: false,
        projectsPaginationModel: { pageSize: 12, page: 0 },
        projectsSearchQuery: "",
    },
    reducers: {
        setProjects: (state, action) => {
            state.projects = action.payload
        },
        setCurrentProject: (state, action) => {
            state.currentProject = action.payload
        },
        setSelectedProjectId: (state, action) => {
            state.selectedProjectId = action.payload
        },
        setProjectsLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setProjectsPaginationModel: (state, action) => {
            state.projectsPaginationModel = action.payload
        },
        setProjectsSearchQuery: (state, action) => {
            state.projectsSearchQuery = action.payload
        },
    },
})

export const {
    setProjects,
    setCurrentProject,
    setSelectedProjectId,
    setProjectsLoading,
    setProjectsPaginationModel,
    setProjectsSearchQuery,
} = projectsSlice.actions

export default projectsSlice.reducer
